import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RoleGuard({ allow, children }) {
  const { user } = useAuth();
  if (user && !allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
